module.exports = __webpack_public_path__ + "static/img/vistion-and-mission.1909e36b.jpg";